/**
 * @param {import("../../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/tools",
    },
    (router) => {
      router.push({
        id: "@api-legacy/tool@place-autocomplete",
        path: "/place-autocomplete",
      });
    },
  );
}
